import { type CatalogueProductView } from '../../contracts';
import { type SuggestableProductTier, suggestTier } from '../suggest-tier';
import { useQueryComplimentaryUsage } from './useQueryComplimentaryUsage';

export type UseSuggestedTierProps = {
  hasUser: boolean;
  /** The v3 catalogue, from the caller's products query. */
  products: readonly CatalogueProductView[] | undefined;
  newProductTier: SuggestableProductTier;
  enabled?: boolean;
};

export type UseSuggestedTierResult = {
  /** Null when the member has no ended complimentary cycle or no plan of the tier has a limit. */
  suggestedProduct: CatalogueProductView | null;
  isLoading: boolean;
  isSuccess: boolean;
};

/** The plan of `newProductTier` sized to the member's last complimentary cycle of usage. */
export function useSuggestedTier({
  hasUser,
  products,
  newProductTier,
  enabled = true,
}: UseSuggestedTierProps): UseSuggestedTierResult {
  const usageQuery = useQueryComplimentaryUsage({ hasUser, enabled });

  const usage = usageQuery.data;
  const suggestedProduct =
    usage == null || products == null
      ? null
      : suggestTier({ consumed: usage.consumed, products, newProductTier });

  return {
    suggestedProduct,
    isLoading: usageQuery.isLoading,
    isSuccess: usageQuery.isSuccess && products != null,
  };
}
